/* @flow */

import React from 'react';

import * as reportingPermissions from 'permissions/reporting';
import { canBatchImport } from 'permissions/account';
import Brands from 'tables/Reporting/Brands';
import Brand from 'tables/Reporting/Brand';
import TradingAccount from 'tables/Reporting/TradingAccount';
import BrandForm from 'forms/BrandForm';
import MultipleBrandForm from 'forms/BrandForm/MultipleBrandForm';
import { brandStore, accountStore } from 'services/ServiceRegistry';
import { isEnabled } from 'utils/FeatureFlag';

import type { RouteResolver } from './types';

const routes = [
  {
    path: '/reporting',
    title: 'general:document_titles.reporting.title',
    component: Brands,
    exact: true,
    permissions: reportingPermissions.viewAllBrands,
  },
  {
    path: '/reporting/brand/:brandId',
    title: 'general:document_titles.reporting.brand',
    title_keys: ['selectedBrand.name'],
    component: class BrandReportViewWrapper extends React.PureComponent {
      constructor(props: *) {
        super(props);

        const { brandId } = props.match.params;
        if (brandId) {
          brandStore.loadBrand(brandId);
        }
      }

      render() {
        return <Brand {...this.props} />;
      }
    },
    exact: true,
    permissions: reportingPermissions.viewAllBrands,
  },
  {
    path: '/reporting/brand/:brandId/account/:accountId',
    title: 'general:document_titles.reporting.brand_account',
    title_keys: ['selectedBrand.name', 'details.details.account_no'],
    component: class AccountReportViewWrapper extends React.PureComponent {
      constructor(props) {
        super(props);

        const { accountId, brandId } = props.match.params;
        if (brandId) {
          brandStore.loadBrand(brandId);
        }
        if (accountId) {
          accountStore.loadDetails(accountId);
        }
      }

      render() {
        return <TradingAccount {...this.props} />;
      }
    },
    exact: true,
    permissions: reportingPermissions.viewAllBrands,
  },
  {
    path: '/brands/create',
    title: 'general:document_titles.reporting.create_brand',
    component: () => <BrandForm mode="create" />,
    exact: true,
    permissions: reportingPermissions.createBrands,
  },
  {
    path: '/brands/create-multiple',
    title: 'general:document_titles.reporting.create_multiple_brands',
    component: () => <MultipleBrandForm />,
    exact: true,
    permissions: canBatchImport,
  },
  {
    path: '/brands/edit/:brandId',
    title: 'general:document_titles.reporting.edit_brand',
    title_keys: ['selectedBrand.name'],
    component: props => (
      <BrandForm
        key={props.match.params.brandId}
        mode="edit"
        brandId={props.match.params.brandId}
      />
    ),
    exact: true,
    permissions: reportingPermissions.createBrands,
  },
];

const emptyRoutes = [];

const reportingRoutes: RouteResolver = roleId =>
  isEnabled('reporting', roleId) ? routes : emptyRoutes;

export default brandId =>
  reportingRoutes(brandId).map(item => ({
    ...item,
    store: ['brandStore', 'accountStore'],
  }));
